import { get } from '@/request/request'

export default {
    getCaptcha() {
        return get('/captcha')
    },
}